import React, { useContext, useState } from 'react';
import axios from 'axios';
import { baseUrl } from '../utils/constants';

const initialBatch = {
  // batchID: '',
  batch_No: '',
  provider_Id: 0,
  no_of_Docs: 0,
  self_Payments: 0,
  prepayment: 0,
  batchTotal: 0,
  personal_Account: 0,
  payCycleID: '',
  treatMonth: '',
  entered: false,
  isSelfPayment: false,
  batchStatus_Id: 1,
  workStation: '',
  userRefId: 0,
  batchReceivedOn: ''
};

const initialClaim = {
  claim_ID: 0,
  batchID: 0,
  medFundNumber: '',
  cif_Number: '',
  provider_Id: '',
  namasNo: '',
  invoice_No: '',
  parent_Cif: '',
  pay_Cycle_Date: '',
  referring_Practitioner: 0,
  diagnosis: '',
  personalAcReason: '',
  diagnosis_Id: 0,
  self_Payment: false,
  status_Id: 0,
  currentAge: 0,
  currencyId: 0,
  userId: 0,
  workStation: '',
  claimantType_id: 0,
  scheme_id: 0,
  service_Type_id: '',
  clearanceRequest_id: 0,
  awardedAmt: 0,
  memberType_id: 0,
  group_id: 0,
  dependantId: 0,
  retirementTypeId: 1,
  dateOfRetirement: '',
  // dateOfDeath: '',
  circumstance: '',
  claimantMobile: '',
  claimantForename: '',
  claimantSurname: '',
  claimantIdNumber: '',
  claimantRelation: '',
  bankRefId: '',
  bankBranchRefId: '',
  sortCode: '',
  accountName: '',
  accountNumber: '',
  dateCreated: new Date()
};

const initialLine = {
  claim_Id: 0,
  tarrif_id: 0,
  tarif_Code: '',
  period: '',
  mod: '',
  units: 1,
  dates: '',
  amtClaimed: 0.0,
  tariffAmt: 0.0,
  personalAc: 0.0,
  department_id: '',
  status_Code: '',
  amtPaid: 0.0,
  currency_id: 3,
  treatmentDate: '',
  overrideValidityPeriod: false,
  forceShortfall: false,
  shortfallAmt: 0.0,
  duplicateClaimId: 0,
  payeeType_Id: 0,
  userId: 0,
  savingsAmt: 0.0,
  applyModifiers: false,
  manuallyPay: false,
  manuallyPayAmt: 0.0
};

export const ClaimsContext = React.createContext();

export const ClaimsProvider = ({ children }) => {
  const [batchNo, setBatchNo] = useState(-1);
  const [currentBatch, setCurrentBatch] = useState(initialBatch);
  const [claimNo, setClaimNo] = useState(-1);
  const [currentClaim, setCurrentClaim] = useState(initialClaim);
  const [showDetails, setShowDetails] = useState(false);
  const [claimLine, setClaimLine] = useState(initialLine);
  const [claimDetailsList, setClaimDetailsList] = useState([]);
  const [claimDocsList, setClaimDocsList] = useState([]);
  const [usageList, setUsageList] = useState([]);
  const [usageTotal, setUsageTotal] = useState({
    scheme: 'Main',
    globalLimit: 'Global Limit',
    totalLimit: 0,
    usedToDate: 0,
    amountClaimed: 0,
    availableBalance: 0
  });

  const clearClaims = () => {
    setClaimNo(-1);
    setCurrentClaim(initialClaim);
    setClaimDetailsList([]);
  };

  const clearBatch = () => {
    setBatchNo(-1);
    setCurrentBatch(initialBatch);
  };

  const clearLineItem = () => {
    setClaimLine(initialLine);
  };

  const refreshClaimById = async (claimId) => {
    await axios(`${baseUrl}/api/claims/getClaimById?claimId=${claimId}`).then(
      (result) => {
        console.log('returned claim info in context', result);
        setCurrentClaim(result.data.result);
      },
      (error) => {
        alert('failed');
      }
    );
  };

  const refreshClaimLineById = async (id) => {
    await axios(`${baseUrl}/api/claims/GetClaimLineById?claimDtl_id=${id}`).then(
      (result) => {
        console.log('returned claim line info in context', result);
        setClaimLine(result.data.result);
      },
      (error) => {
        alert('failed');
      }
    );
  };

  const getClaimDetailsById = async (claimIds) => {
    await axios(`${baseUrl}/api/claims/GetClaimReportDetails?claimId=${claimIds}`).then(
      (result) => {
        console.log('returned claim details info', result);
        setClaimDetailsList(result.data.result);
      },
      (error) => {
        alert('failed');
      }
    );
  };

  const getClaimById = async (e) => {
    console.log('e at getClaimId', e);
    if (e === -1) {
      return;
    }
    if (e === 0) {
      // setCurrentClaim({});
      return;
    }
    await axios(`${baseUrl}/api/claims/getClaimById?claimId=${e}`).then(
      (result) => {
        console.log('returned getClaimById info', result);
        setCurrentClaim(result.data.result);
        console.log('result.data.result provider_Id', result.data.result.provider_Id);
      },
      (error) => {
        alert('failed');
      }
    );
  };

  const getLimitUsage = async (client) => {
    console.log('client dependant', client);
    // await axios(
    //   `${baseUrl}/api/claims/getLimitUsage?cifNumber=${client.cif_number}&memberTypeId=${client.memberType_ID}&schemeId=1`
    // ).then(
    //   (result) => {
    //     console.log('returned Limits Usage', result);
    //     setUsageList(result.data.result);
    //   },
    //   (error) => {
    //     alert('failed');
    //     // notifyPopup(`Error in Getting Claim!: ${error}`, 'error');
    //   }
    // );
  };

  const getLimitTotalUsage = async (client) => {
    console.log('client dependant', client);
    // await axios(
    //   `${baseUrl}/api/claims/getLimitTotalUsage?cifNumber=${client.cif_number}&memberTypeId=${client.memberType_ID}&schemeId=1}`
    // ).then(
    //   (result) => {
    //     console.log('returned setUsageTotal Usage', result);
    //     setUsageTotal(result.data.result[0]);
    //   },
    //   (error) => {
    //     alert('failed');
    //     // notifyPopup(`Error in Getting Claim!: ${error}`, 'error');
    //   }
    // );
  };

  const populateClaimDocuments = async (claimNo) => {
    const response = await fetch(`${baseUrl}/api/client/getdocumentsbyclaim?claimId=${claimNo}`);
    const data = await response.json();
    console.log('documents data received 9999', data);
    if (data.result.length > 0) {
      console.log('documents data received 55555', data.result);
      setClaimDocsList(data.result);
    } else {
      console.log('documents data received 77777', data.result);
      setClaimDocsList([]);
    }
  };

  return (
    <ClaimsContext.Provider
      value={{
        batchNo,
        setBatchNo,
        currentBatch,
        setCurrentBatch,
        clearBatch,
        currentClaim,
        setCurrentClaim,
        claimNo,
        setClaimNo,
        setClaimDetailsList,
        claimDetailsList,
        getClaimDetailsById,
        clearClaims,
        getLimitUsage,
        usageList,
        refreshClaimById,
        claimLine,
        setClaimLine,
        refreshClaimLineById,
        clearLineItem,
        getLimitTotalUsage,
        usageTotal,
        showDetails,
        setShowDetails,
        getClaimById,
        claimDocsList,
        setClaimDocsList,
        populateClaimDocuments
      }}
    >
      {children}
    </ClaimsContext.Provider>
  );
};

export const useClaimsContext = () => useContext(ClaimsContext);
